import { AddNewStageService, CustomToastrAction } from "@/imports-files/components/add-new-stage";
import { PageStyle, ButtonStyle , Button, INTERVIEW_TYPES} from '@/imports-files/pages/clients/jobs/automations';

export class AddNewStageAction
{
  constructor()
  {
   this.customToastrAction = new CustomToastrAction();
   this.addNewStageService = new AddNewStageService();
  }

  async submitForm(values, setBtnPopup, jobData, setJobData, setIsLoading){
    const params = {job_stage: values}
    const result = await this.addNewStageService.addStage(params, jobData.id)
    if(result.request.status == 200){
      setIsLoading(false)
      setJobData(result.data.kanban_data)
      setBtnPopup(false)
      this.customToastrAction.setNormalToastr(result.data.success, 'success');
    }
    else{
      if(typeof result.response.data.error === 'string'){
        this.customToastrAction.setNormalToastr(result.response.data.error, 'error');
      }
      else{
        return result.response.data.error.job_stage
      }
    }
  }

  async getJobInfo(jobId){
    const result = await this.addNewStageService.addStageInfo(jobId)
    if(result.request.status == 200){
      return result.data
    }
    else{
      return result.response.data.error
    }
  }

  async onSuggestionSelection(emails, email, emailInitials, emailInitial){
    if(!emails.includes(email))
    {
      emails.unshift(email)
      emailInitials.unshift(emailInitial)
    }
  }

  async handleDelete(formik, itemIndex){
    let member_emails = formik.values.member_emails
    let member_initials = formik.values.member_initials
    member_emails.splice(itemIndex, 1)
    member_initials.splice(itemIndex, 1)
    formik.setFieldValue(`member_emails`, [...member_emails])
    formik.setFieldValue(`member_initials`, [...member_initials])
  }

  renderInputComponent = inputProps => (
    <div className="buttonIn">
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      { <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn`} disabled={inputProps.disabled} onClick={() => inputProps.addNewStageAction.onAddClick(event, inputProps)}>Add</Button> }
    </div>
  )

  onAddClick(event, params){
   let email = params.value 
    if(params.addNewStageAction.isEmail(email)){
      params.addNewStageAction.onSuggestionSelection(params.formik.values.member_emails, email, params.formik.values.member_initials, {email: email, name_initials: null, name: null })
      params.setStageEmail('')
      params.formik.setStatus({})
    }
    else{
      params.formik.touched['member_emails'] = true;
      params.formik.setStatus({'member_emails': 'Please enter valid email'})
    }
  }

  isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  handleKeyDown(event, formik, setStageEmail, addNewStageAction){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value 
      if(addNewStageAction.isEmail(email)){
        addNewStageAction.onSuggestionSelection(formik.values.member_emails, email, formik.values.member_initials, {email: email, name_initials: null, name: null })
        formik.setStatus({})
        setStageEmail('')
      }
      else{
        formik.touched['member_emails'] = true;
        formik.setStatus({'member_emails': 'Please enter valid email'})
      }
    }
  }
}